@if (eventModel && eventModel.ID > 0) {
    <div class="detail-page-summary">
        <div class="row">
            <div class="col-6">
                <div class="property"><b>{{ 'detailMain.summaryId' | t }}</b> {{ eventModel.Identifier }}</div>
                <div class="property">
                    <b>{{ 'detailMain.summaryName' | t }}</b> &nbsp;<span data-uiid="event-name-label">{{
                        eventModel.Name
                    }}</span>
                </div>
                <div class="property">
                    <b>{{ 'detailMain.summaryRegistrationDate' | t }}</b> {{ eventModel.DateCreated | dateFormat }}
                </div>
            </div>
            <div class="col-6">
                <div class="property">
                    <b>{{ 'detailMain.summaryDateOccurred' | t }}</b> {{ eventModel.DateOccurrence | dateFormat }}
                </div>
                <div class="property">
                    <b>{{ 'detailMain.summaryDateDetected' | t }}</b> {{ eventModel.DateDetection | dateFormat }}
                </div>
                <div class="property">
                    <b>{{ 'detailMain.summaryDateClosed' | t }}</b> {{ eventModel.DateClosed | dateFormat }}
                </div>
            </div>
        </div>
    </div>
}

<event-comments [eventGuid]="eventModel.Guid" #comments> </event-comments>

@if (eventModel) {
    <form [formGroup]="parentForm">
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'detailMain.eventDetailsTitle' | t }}</div>
            <div class="detail-page-card-body padded">
                @if (sdHeavy) {
                    <div>
                        <div class="row">
                            <div class="col-12 col-xl-6 left-block">
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textfield
                                            fieldLabel="{{ 'detailMain.eventNameFieldLabel' | t }}"
                                            dataUiid="event-name"
                                            identifier="eventNameInput"
                                            formControlName="Name"
                                            placeholder="Required"
                                        ></cerrix-textfield>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col separator">
                                        <cerrix-textfield
                                            fieldLabel="{{ 'detailMain.internalIdentifierFieldLabel' | t }}"
                                            dataUiid="event-identifier"
                                            identifier="internalIdentifierInput"
                                            formControlName="InternalIdentifier"
                                        ></cerrix-textfield>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="form-group">
                                    <label for="organizationSelect">{{ 'detailMain.organizationLabel' | t }}</label>
                                    <cerrix-select-tree
                                        data-uiid="event-organization"
                                        [tree]="sdHeavy.Organizations"
                                        formControlName="OrganizationId"
                                        placeholder="Required"
                                        [multiselect]="false"
                                        (onChangeSingleId)="reloadBusinessData()"
                                    >
                                    </cerrix-select-tree>
                                </div>
                                <div class="form-group">
                                    <label for="organizationCauserSelect"
                                        >{{ 'detailMain.causedByOrganizationLabel' | t }}</label
                                    >
                                    <cerrix-select-tree
                                        data-uiid="event-causedbyorganization"
                                        [tree]="sdHeavy.Organizations"
                                        formControlName="CausedByOrganizationId"
                                        [multiselect]="false"
                                    >
                                    </cerrix-select-tree>
                                </div>

                                <div class="row">
                                    <div class="form-group col separator">
                                        <label for="organizationSelect"
                                            >{{ 'detailMain.affectedOrganizationLabel' | t }}</label
                                        >
                                        <cerrix-select-tree
                                            data-uiid="event-affectedorganization"
                                            [tree]="sdHeavy.Organizations"
                                            formControlName="AffectedOrganizationId"
                                            [multiselect]="false"
                                        >
                                        </cerrix-select-tree>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="form-group">
                                    <label for="businessDimenionTree">
                                        {{ 'detailMain.businessDimensionsLabel' | t }}
                                        @if (!selectedOrganizationId) {
                                            <i
                                                class="far fa-question-circle ms-2"
                                                [matTooltip]="
                                                    'Please select an organization first.'
                                                "
                                            ></i>
                                        }
                                    </label>
                                    <cerrix-select-tree
                                        data-uiid="event-businessdimension"
                                        [tree]="businessDimensions"
                                        formControlName="BusinessDimensions"
                                        [multiselect]="true"
                                        [readonly]="!selectedOrganizationId"
                                    >
                                    </cerrix-select-tree>
                                </div>
                                <div class="form-group">
                                    <label for="businessLineSelect">{{ 'detailMain.businessLineLabel' | t }}</label>
                                    <ng-select
                                        data-uiid="event-businessline"
                                        id="businessLineSelect"
                                        name="businessLineSelect"
                                        [items]="sdHeavy.BusinessLines"
                                        formControlName="BusinessLineId"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [closeOnSelect]="true"
                                        [multiple]="false"
                                    >
                                    </ng-select>
                                </div>
                            </div>

                            <div class="col-12 col-xl-6 right-block">
                                <div class="form-group-separator d-xl-none"></div>

                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="dateOccurredInput">{{ 'detailMain.dateOccurredLabel' | t }}</label>
                                            <date-input
                                                data-uiid="event-dateoccured"
                                                formControlName="DateOccurrence"
                                                [maxDate]="maxDate"
                                            ></date-input>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="dateDetectedInput">{{ 'detailMain.dateDetectedLabel' | t }}</label>
                                            <date-input
                                                data-uiid="event-datedetected"
                                                formControlName="DateDetection"
                                                [maxDate]="maxDate"
                                            ></date-input>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="form-group">
                                    <label for="eventCategorySelect">{{ 'detailMain.eventCategoryLabel' | t }}</label>
                                    <cerrix-select-tree
                                        data-uiid="event-category"
                                        [tree]="sdHeavy.EventCategories"
                                        formControlName="EventCategoryId"
                                        [multiselect]="false"
                                    >
                                    </cerrix-select-tree>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="incidentTypeSelect">{{ 'detailMain.incidentTypeLabel' | t }}</label>
                                            <ng-select
                                                data-uiid="event-incidenttype"
                                                id="incidentTypeSelect"
                                                name="incidentTypeSelect"
                                                [items]="sdHeavy.IncidentTypes"
                                                formControlName="IncidentTypes"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                placeholder="Required"
                                                [multiple]="true"
                                            >
                                            </ng-select>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="classificationSelect">{{ 'detailMain.classificationLabel' | t }}</label>
                                            <ng-select
                                                data-uiid="event-classification"
                                                id="classificationSelect"
                                                name="classificationSelect"
                                                [items]="sdHeavy.Classifications"
                                                formControlName="ClassificationId"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="true"
                                            >
                                                <ng-template
                                                    ng-label-tmp
                                                    ng-option-tmp
                                                    let-item="item"
                                                >
                                                    <div
                                                        [style.background-color]="item.Color"
                                                        style="
                                                            min-width: 5px;
                                                            min-height: 22px;
                                                            float: left;
                                                            margin-right: 10px;
                                                        "
                                                    ></div>
                                                    {{ item.Name }}
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="row">
                                    <div class="form-group col">
                                        <label for="reporterSelect">{{ 'detailMain.reporterLabel' | t }}</label>
                                        @if (canChangeReporter) {
                                            <ng-select
                                                id="reporterSelect"
                                                name="reporterSelect"
                                                [items]="sdHeavy.Reporter"
                                                formControlName="ReportedById"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        } @else {
                                            <cerrix-textfield
                                                dataUiid="event-reporter"
                                                id="reportInput"
                                                formControlName="ReporterName"
                                            ></cerrix-textfield>
                                        }
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="responsibleSelect">{{ 'detailMain.responsiblesLabel' | t }}</label>
                                        <ng-select
                                            data-uiid="event-responsibles"
                                            id="responsibleSelect"
                                            name="responsibleSelect"
                                            [items]="sdHeavy.Responsibles"
                                            formControlName="Responsible"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="false"
                                            [multiple]="true"
                                            placeholder="Required"
                                        >
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="assessorSelect">{{ 'detailMain.assessorsLabel' | t }}</label>
                                        <ng-select
                                            data-uiid="event-assessors"
                                            id="assessorSelect"
                                            name="assessorSelect"
                                            [items]="sdHeavy.Assessors"
                                            formControlName="Assessor"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="false"
                                            [multiple]="true"
                                            placeholder="Required"
                                        >
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="informedSelect">{{ 'detailMain.informedLabel' | t }}</label>
                                        <ng-select
                                            data-uiid="event-informed"
                                            id="informedSelect"
                                            name="informedSelect"
                                            [items]="sdHeavy.Informed"
                                            formControlName="Informed"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="false"
                                            [multiple]="true"
                                        >
                                        </ng-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </div>

        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'detailMain.eventAnalysisTitle' | t }}</div>
            <div class="detail-page-card-body padded cerrix-control-sm">
                @if (sdLight) {
                    <div>
                        <div class="row">
                            <div class="col-12 col-xl-6 left-block">
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'detailMain.eventDescriptionFieldLabel' | t }}"
                                            dataUiid="event-description"
                                            identifier="eventDescriptionInput"
                                            formControlName="Description"
                                            placeholder="Required"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-12 col-lg-6">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'detailMain.impactDescriptionFieldLabel' | t }}"
                                            dataUiid="event-impactdescription"
                                            identifier="impactDescriptionInput"
                                            formControlName="ImpactDescription"
                                        ></cerrix-textarea>
                                    </div>
                                    <div class="form-group col-12 col-lg-6">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'detailMain.causeDescriptionFieldLabel' | t }}"
                                            dataUiid="event-causedescription"
                                            identifier="causeDescriptionInput"
                                            formControlName="CauseDescription"
                                        ></cerrix-textarea>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>
                            </div>
                            <div class="col-12 col-xl-6 right-block">
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'detailMain.primaryCauseFieldLabel' | t }}"
                                            dataUiid="event-primarycause"
                                            identifier="primaryCauseInput"
                                            formControlName="PrimaryCause"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'detailMain.secondaryCauseFieldLabel' | t }}"
                                            dataUiid="event-secondarycause"
                                            identifier="secondaryCauseInput"
                                            formControlName="SecondaryCause"
                                        ></cerrix-textarea>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-xl-6 left-block">
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'detailMain.effectDescriptionFieldLabel' | t }}"
                                            dataUiid="event-effectdescription"
                                            identifier="effectDescriptionInput"
                                            formControlName="EffectDescription"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="effectsSelect">{{ 'detailMain.effectsLabel' | t }}</label>
                                        <ng-select
                                            data-uiid="event-effects"
                                            id="effectsSelect"
                                            name="effectsSelect"
                                            [multiple]="true"
                                            [items]="sdLight.Effects"
                                            formControlName="Effects"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="false"
                                        >
                                        </ng-select>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'detailMain.reputationImpactDescriptionFieldLabel' | t }}"
                                            data-uiid="event-reputationimpactdescription"
                                            identifier="reputationImpactDescInput"
                                            formControlName="ReputationImpactDescription"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="reputationImpactSelect"
                                            >{{ 'detailMain.reputationImpactLabel' | t }}</label
                                        >
                                        <ng-select
                                            data-uiid="event-reputationimpact"
                                            id="reputationImpactSelect"
                                            name="reputationImpactSelect"
                                            [items]="sdLight.ReputationImpacts"
                                            formControlName="ReputationImpactId"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="true"
                                        >
                                        </ng-select>
                                    </div>
                                </div>

                                <div class="form-group-separator d-xl-none"></div>
                            </div>
                            <div class="col-12 col-xl-6 right-block">
                                <div class="row">
                                    <div class="form-group col-6">
                                        <label for="grossImpactNumber">{{ 'detailMain.grossImpactLabel' | t }}</label>
                                        <input
                                            data-uiid="event-grossimpact"
                                            type="number"
                                            class="form-control form-control-sm"
                                            id="grossImpactNumber"
                                            name="grossImpactNumber"
                                            formControlName="GrossCosts"
                                            step="0.01"
                                            data-number-to-fixed="2"
                                            data-number-stepfactor="100"
                                            (change)="calculateNetCosts()"
                                        />
                                    </div>
                                    <div class="form-group col-6">
                                        <label for="recoveryNumber">{{ 'detailMain.recoveryLabel' | t }}</label>
                                        <input
                                            data-uiid="event-recovery"
                                            type="number"
                                            class="form-control form-control-sm"
                                            id="recoveryNumber"
                                            name="recoveryNumber"
                                            formControlName="Recovery"
                                            (change)="calculateNetCosts()"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="netImpactText">{{ 'detailMain.nettImpactLabel' | t }}</label>
                                        <input
                                            data-uiid="event-nettimpact"
                                            type="number"
                                            class="form-control form-control-sm"
                                            id="netImpactText"
                                            name="netImpactText"
                                            formControlName="NetCosts"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="currencySelect">{{ 'detailMain.currencyLabel' | t }}</label>
                                        <ng-select
                                            data-uiid="event-currency"
                                            id="currencySelect"
                                            name="currencySelect"
                                            formControlName="CurrencyCode"
                                            [items]="sdLight.Currencies"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="false"
                                        >
                                        </ng-select>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'detailMain.riskOpinionFieldLabel' | t }}"
                                            dataUiid="event-riskopinion"
                                            identifier="riskOpinionInput"
                                            formControlName="RiskOpinion"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'detailMain.commentsFieldLabel' | t }}"
                                            dataUiid="event-comments"
                                            identifier="commentsInput"
                                            formControlName="Comments"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </div>

        <!-- Custom fields -->
        @if (eventCustomFieldsFormGroup && customFieldStandingDataModel.any()) {
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ 'detailMain.customFieldsTitle' | t }}</div>
                <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
                    <cerrix-custom-fields-editor
                        [parentForm]="eventCustomFieldsFormGroup"
                        [customFieldData]="customFieldData"
                        [singleColumn]="false"
                    ></cerrix-custom-fields-editor>
                </div>
            </div>
        }
    </form>
}
